import React, { useState } from "react";
import "./MakePayment.css";

const ClientDashboardMakePayment = () => {
  return (
    <div className="clientdashboard__makepayment_section">
      <div className="clientdashboard__makepayment_wrapper">
        <div className="clientdashboard__makepayment_banner">Make Payment</div>
        <div className="clientdashboard__makepayment_tablewrap">
          <table className="clientdashboard__makepayment_table">
            <thead className="clientdashboard__makepayment_thead">
              <tr>
                <td>For</td>
                <td>Refund/Due</td>
                <td>Payment</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Discount</td>
                <td></td>
                <td>
                  <input
                    type="text"
                    className="clientdashboard__makepayment_inputfield"
                    placeholder="Please Enter the Discount"
                  />
                </td>
              </tr>
              <tr>
                <td>Total</td>
                <td>
                  <input
                    type="text"
                    className="clientdashboard__makepayment_inputfield"
                    placeholder="Please Enter the Amount to Pay"
                  />
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="clientdashboard__makepayment_bottombtnwrap">
          <button className="clientdashboard__makepayment_makepaymentbtn">
            Make Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardMakePayment;
